<template>
  <div>
		<el-form-item :label="label" :required="required"></el-form-item>
		<div class="contact_info_wrapper">
			<div class="add-line" v-for="(form, key, index) in contact_infos" :key="key">
				<el-form-item label="" :rules="originRule['info_type_id']" :prop="name + 'info_type_id' + key">
					<el-select style="width: 70px" v-model="form['info_type_id']" @change="(ev) => infoChange(ev, key, 'info_type_id')" :placeholder="$t('common.category')">
						<el-option v-for="o in msgList" :key="o.label" :label="o.name" :value="o.id"></el-option>
					</el-select>
				</el-form-item>
				<div class="second-line">
					<template v-if="form['info_type'] === '手机'">
						<div class="phone-mobile">
							<el-form-item label-width="0" label="" style="flex-basis: 80px">
								<country-code-select v-model="form['mobile']['area']" :placeholder="$t('portal.qing-xuan-ze')" @change="(e) => change(e, 'mobile_area', key)"></country-code-select>
							</el-form-item>
							<el-form-item label-width="0" class="ml5 flex1" label="" :rules="originRule['mobile_number']" :prop="name + 'mobile_number' + key">
								<el-input :placeholder="$t('portal.shou-ji')" v-model="form['mobile']['number']" maxlength="16" minlength="8" autocomplete="off" @change="(e) => change(e, 'mobile_number', key)"> </el-input>
							</el-form-item>
						</div>
					</template>
					<template v-else-if="form['info_type'] === '座机' || form['info_type'] === '传真'">
						<div class="zuoji">
							<el-form-item label-width="0" label="" style="flex-basis: 60px">
								<country-code-select v-model="form['phone']['area']" :placeholder="$t('portal.qing-xuan-ze')" @change="(e) => change(e, 'phone_area', key)"></country-code-select>
							</el-form-item>
							<el-form-item label-width="0" label="" class="ml5" style="flex-basis: 60px" :rules="form['phone']['area'] === '86' ? originRule['phone_city_required'] : originRule['phone_city']" :prop="name + 'phone_city' + key">
								<el-input :placeholder="$t('portal.qu-hao')" v-model="form['phone']['city']" maxlength="5" minlength="2" autocomplete="off" @change="(e) => change(e, 'phone_city', key)"> </el-input>
							</el-form-item>
							<el-form-item label-width="0" label="" class="ml5 flex1" :rules="originRule['phone_number']" :prop="name + 'phone_number' + key">
								<el-input :placeholder="$t('portal.dian-hua')" v-model="form['phone']['number']" maxlength="8" minlength="6" autocomplete="off" @change="(e) => change(e, 'phone_number', key)"></el-input>
							</el-form-item>
							<el-form-item label-width="0" label="" class="ml5 flex1" :rules="originRule['phone_extension']" :prop="name + 'phone_extension' + key">
								<el-input :placeholder="$t('portal.fen-ji')" v-model="form['phone']['extension']" maxlength="6" minlength="1" autocomplete="off" @change="(e) => change(e, 'phone_extension', key)"></el-input>
							</el-form-item>
						</div>
					</template>
					<template v-else>
						<el-form-item label-width="0" label="" :rules="originRule['value']" :prop="name + 'value' + key + '__' + selectName">
							<el-input v-model="form['value']" :placeholder="$t('portal.lian-xi-xin-xi')" autocomplete="off" @change="(e) => change(e, 'value', key)"></el-input>
						</el-form-item>
					</template>
				</div>
				<div class="control" v-if="!single">
					<i class="el-icon-circle-plus-outline icon" @click="addItem(key)" v-if="dataLen.length - 1 == index"></i>
					<i class="el-icon-remove-outline icon" @click="removeItem(key)" v-if="dataLen.length != 1"></i>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
import CountryCodeSelect from '~/common/components/select/CountryCodeSelect.vue';
import { regexURL, regexIP, regexEmail, regexMobile, regexPhone, regexWX, regexQQ } from '~/common/utils/validate';
export default {
  components: {
    CountryCodeSelect
  },
  computed: {
    dataLen() {
      return Object.keys(this.contact_infos);
    }
  },
  props: {
    label: {
      type: String,
      default: 'portal.xin-xi-lei-bie'
    },
    model: {
      type: Object
    },
    name: {
      type: String
    },
    value: {
      type: Array,
      default: () => []
    },
    required: {
      type: Boolean
    },
    single:{
      type: [Boolean, undefined, null],
      default: () => false
    },
    rule: {
      /**
          * 局部校验。自定义每个输入框校验规则  按理说可以被覆盖，暂时没有这个场景，所以没写这个逻辑
          * {
               name: "contact_infos",
               type: "contact_info",
               span: 24,
               required: true,
               rule: {
                 info_type_id: [{required: true,message: this.must({msg:'信息类别'})}],
                 mobile_number: [{required: true,message: this.must({msg:'手机'})}],
                 // phone_city: [{required: true,message: this.must({msg:'区号'})}],
                 phone_number: [{required: true,message: this.must({msg:'电话'})}],
                 // phone_extension: [{required: true,message: this.must({msg:'分机'})}],
                 value: [{required: true,message: this.must({msg:'信息'})}],
               }
             },
          */
      type: Object,
      default: () => {
        return null;
      }
    }
  },
  data() {
    const rexMobile = (rule, value, callback) => {
      const area = this.contact_infos[this.mobileKey]?.mobile?.area;
      let that = this;
      let flag = false;
      if (area === '86') {
        flag = /^1\d{10}$/.test(value);
      } else {
        flag = /^\d{7,11}$/.test(value);
      }
      if (flag) {
        callback();
      } else {
        callback(new Error(that.$t('portal.ge-shi-cuo-wu')));
      }
    };
    const rexPhone = (rule, value, callback) => {
      let that = this;
      if (value === '') {
        callback();
        return;
      }
      if (/\d{6,8}/.test(value)) {
        callback();
      } else {
        callback(new Error(that.$t('portal.ge-shi-cuo-wu')));
      }
    };
    const rexCity = (rule, value, callback) => {
      let that = this;
      if (value === '') {
        callback();
        return;
      }
      if (/\d{1,4}/.test(value)) {
        callback();
      } else {
        callback(new Error(that.$t('portal.ge-shi-cuo-wu')));
      }
    };
    const rexeExtension = (rule, value, callback) => {
      let that = this;
      if (value === '') {
        callback();
        return;
      }
      if (/\d{1,8}/.test(value)) {
        callback();
      } else {
        callback(new Error(that.$t('portal.ge-shi-cuo-wu')));
      }
    };
    const rexSome = (rule, value, callback) => {
      const regName = rule.field.split('__')[1];
      let that = this;
      let f = true;
      if (regName === 'QQ') {
        f = regexQQ(value);
      } else if (regName === that.$t('portal.wei-xin')) {
        f = regexWX(value);
      } else if (regName === that.$t('login.email')) {
        f = regexEmail(value);
      } else if (regName === 'IP') {
        f = regexIP(value);
      } else if (regName === that.$t('portal.wang-zhi')) {
        f = regexURL(value);
      }
      if (f) {
        callback();
      } else {
        callback(new Error(that.$t('portal.ge-shi-cuo-wu')));
      }
    };
    return {
      msgList: [],
      contact_infos: {
        0: {
          info_type_id: '',
          info_type: '',
          value: '',
          mobile: {
            area: '86',
            number: ''
          },
          phone: {
            area: '86',
            extension: '',
            number: '',
            city: ''
          }
        }
      },
      primaryMobileId: '',
      selectName: '',
      originRule: {
        //固定校验
        info_type_id: [{
          required: true,
          message: this.must({
            msg: this.$t('portal.lian-xi-fang-shi')
          })
        }],
        mobile_number: [{
          required: true,
          message: this.must({
            msg: this.$t('portal.shou-ji')
          })
        }, {
          validator: rexMobile,
          trigger: 'blur'
        }],
        phone_city_required: [{
          required: true,
          message: this.must({
            msg: this.$t('portal.qu-hao')
          })
        }, {
          validator: rexCity
        }],
        phone_city: [{
          validator: rexCity
        }],
        phone_number: [{
          required: true,
          message: this.must({
            msg: this.$t('portal.dian-hua')
          })
        }, {
          validator: rexPhone
        }],
        phone_extension: [{
          validator: rexeExtension
        }],
        value: [{
          required: true,
          message: this.must({
            msg: this.$t('portal.xin-xi')
          })
        }, {
          validator: rexSome
        }]
      },
      selfChange: false
    };
  },
  watch: {
    value:{
      immediate:true,
      deep:true,
      handler:function(val) {
        if (!val || val.length < 1) {
          this.contact_infos = {
            0: {
              info_type_id: this.primaryMobileId,
              info_type: this.$t('portal.shou-ji'),
              value: '',
              mobile: {
                area: '86',
                number: ''
              },
              phone: {
                area: '86',
                extension: '',
                number: '',
                city: ''
              }
            }
          };
          for (let k in this.model) {
            if (k.startsWith(this.name)) {
              this.$delete(this.model, k);
            }
          }
        } else {
          if (this.selfChange) return;
          val.map((v, k) => {
            try {
              let tmp = {
              info_type_id: '',
              info_type: '',
              value: '',
              mobile: {
                area: '86',
                number: ''
              },
              phone: {
                area: '86',
                extension: '',
                number: '',
                city: ''
              }
            };
            const {
              info_type,
              value,
              info_type_id
            } = v;
            tmp['info_type_id'] = info_type_id;
            tmp['info_type'] = info_type;
            if (info_type === this.$t('portal.shou-ji')) {
              if(!value) {
                tmp['mobile'].area = '86'
              } else {
                const arr = value.split(' ').filter(v => v);
                tmp['mobile'].area = arr[0];
                tmp['mobile'].number = arr[1];
              }
             
            } else if (info_type === this.$t('portal.zuo-ji') || info_type === this.$t('portal.chuan-zhen')) {
              const arr = value.split(' ').filter(v => v);
              if (arr.length === 2) {
                tmp['phone'].area = arr[0];
                tmp['phone'].number = arr[1];
                tmp['phone'] = {
                  area: arr[0],
                  city: arr[1],
                  number: '',
                  extension: ''
                };
              } else if (arr.length === 3) {
                if (/\d{6,8}/.test(arr[1])) {
                  tmp['phone'] = {
                    area: arr[0],
                    city: '',
                    number: arr[1],
                    extension: arr[2]
                  };
                } else if (arr[1].length < 6) {
                  tmp['phone'] = {
                    area: arr[0],
                    city: arr[1],
                    number: arr[2],
                    extension: ''
                  };
                }
              } else {
                tmp['phone'] = {
                  area: arr[0],
                  city: arr[1],
                  number: arr[2],
                  extension: arr[3]
                };
              }
            } else {
              tmp['value'] = value;
            }
            this.contact_infos[k] = tmp;
            } catch (error) {
              console.log(error)
            }
          });

        }
      }
    },
    contact_infos: {
      immediate: true,
      deep: true,
      handler: function (val) {
        for (let key in val) {
          for (let label in val[key]) {
            const item = val[key][label];
            if (label === 'mobile' || label === 'phone') {
              for (let name in item) {
                this.$set(this.model, this.name + `${label}_${name}` + key, item[name]);
              }
            } else if (label === 'value') {
              this.$set(this.model, this.name + label + key + '__' + this.selectName, val[key][label]);
            } else {
              this.$set(this.model, this.name + label + key, val[key][label]);
            }
          }
        }
      }
    }
  },
  created() {
    this.getContactTypeList();
  },
  mounted() {},
  methods: {
    getContactTypeList() {
      this.$store.dispatch('erp/account/getContactType', {}).then(list => {
        this.msgList = list;
        const item = list.filter(v => v.name === this.$t('portal.shou-ji'))[0];
        this.primaryMobileId = item.id;
        this.$set(this.model, this.name + 'info_type_id' + '0', this.primaryMobileId);
        this.contact_infos['0'].info_type_id = this.primaryMobileId;
        this.contact_infos['0'].info_type = this.$t('portal.shou-ji');
      });
    },
    addItem(key) {
      let item = {
        info_type_id: this.primaryMobileId,
        info_type: this.$t('portal.shou-ji'),
        value: '',
        mobile: {
          area: '86',
          number: ''
        },
        phone: {
          area: '86',
          extension: '',
          number: '',
          city: ''
        }
      };
      this.$nextTick(() => {
        this.$set(this.contact_infos, `${Number(key) + 1}`, item);
      });
    },
    removeItem(key) {
      const len = this.dataLen.length;
      if (len === 1) {
        this.$message({
          message: this.$t('portal.zhi-shao-bao-liu-yi-tiao-shu-ju'),
          type: 'warning'
        });
        return false;
      }
      this.$nextTick(() => {
        this.$delete(this.contact_infos, key);
      });
    },
    infoChange(data, key, name) {
      let selected = this.msgList.filter(({
        id
      }) => id === data)[0];
      this.selectName = selected.name;
      this.$set(this.contact_infos[key], 'info_type', selected.name);
      this.$set(this.contact_infos[key], 'value', '');
      this.$set(this.contact_infos[key], 'mobile', {
        area: '86',
        number: ''
      });
      this.$set(this.contact_infos[key], 'phone', {
        area: '86',
        extension: '',
        number: '',
        city: ''
      });
      this.change(data, name, key);
    },
    change(e, label, key) {
      this.selfChange = true;
      // this.$set(this.model, this.name + label="" + key, e);
      const arr = [];
      for (let k in this.contact_infos) {
        const {
          mobile,
          phone,
          info_type_id,
          value,
          info_type
        } = this.contact_infos[k];
        let strArr = [];
        if (mobile.number) {
          strArr.push(mobile.area, mobile.number);
        } else if (phone.number) {
          strArr.push(phone.area, phone.city, phone.number, phone.extension);
        } else {
          strArr.push(value);
        }
        strArr = strArr.filter(v => v);
        const str = strArr.join(' ');
        arr.push({
          info_type_id,
          value: str,
          info_type
        });
      }
      if (label === 'mobile_number') {
        const tmp = e.replace(/\D/g, '');
        this.$set(this.contact_infos[key]['mobile'], 'number', tmp * 1);
        this.mobileKey = key;
      }
      this.$emit('input', arr);
    }
  }
};
</script>
<style lang="less">
.error-deal .el-col .contact_info_wrapper .el-form-item__error {
	top: -26px;
}
.contact_info_wrapper {
	width: 100%;
	margin-top: -30px;
	float: left;
	.add-line {
		line-height: 1;
		display: flex;
		align-items: center;
		.icon {
			margin-left: 5px;
			color: @linkColor;
		}
	}
	.control {
		width: 40px;
		display: flex;
		align-items: center;
	}
	.second-line {
		margin-left: 5px;
		flex: 1;
	}
	.el-form-item.hiddenStar.is-required:not(.is-no-asterisk) > .el-form-item__label:before {
		content: '';
		margin: 0;
	}
	.ml5 {
		margin-left: 2px;
	}
	.flex1 {
		flex: 1;
	}
	.zuoji,
	.phone-mobile {
		display: flex;
		align-items: center;
	}
	.el-input__inner {
		padding: 0 5px;
	}
}
</style>
